/** Base pathname for recruitment vacancy APIs (use for MSW regex builders). */
export const VACANCY_BASE_PATH = '/rec/vacancy';

export const VACANCY_ENDPOINTS = {
  search: `${VACANCY_BASE_PATH}/search`,
  list: `${VACANCY_BASE_PATH}/list`,
  add: `${VACANCY_BASE_PATH}/add`,
  vacancyCodes: `${VACANCY_BASE_PATH}/vacancyCodes`,
  /** Route params from `useParams` are strings; services may pass numbers. */
  byId: (id: string | number) => `${VACANCY_BASE_PATH}/${id}`,
  clone: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/clone`,
  publishJob: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/publishJob`,
  deleteJob: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/deleteJob`,
  withdraw: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/withdraw`,
  approve: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/approve`,
  /** Active Jira statuses a stage can be mapped to. */
  /** Deletes one saved vacancy question (stage questions included); the stage save never removes questions. */
  deleteQuestion: (questionId: number) =>
    `${VACANCY_BASE_PATH}/deleteQuestion?questionId=${questionId}`,
  jiraStatuses: `${VACANCY_BASE_PATH}/jira-statuses`,
  stages: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/stages`,
  stage: (id: string | number, stageId: string | number) =>
    `${VACANCY_BASE_PATH}/${id}/stages/${stageId}`,
  reorderStages: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/stages/reorder`,
  stageQuestions: (id: string | number, stageId: string | number) =>
    `${VACANCY_BASE_PATH}/${id}/stages/${stageId}/questions`,
  updateDetails: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/updateDetails`,
  updateJD: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/updateJD`,
  updateMedia: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/updateMedia`,
} as const;
